
import BaseFooterComponent from "@/components/Shared/BaseFooter/BaseFooterComponent";
export default BaseFooterComponent;
